import SimpleReactValidator from 'shared/utils/simple-react-validator';
import { selectStencilsForValidation } from 'shared/product_tabs/tab_stencils/slice/selectors';
import { updateValidatorFlag } from 'shared/product_tabs/tab_stencils/slice/stencilsSlice';
import { changeTab } from 'shared/product_tabs/tabs/tabSlice';
import { TAB_STENCILS } from 'shared/product_tabs/tabs/tabType';
import { toast } from 'react-hot-toast';

export const validator = new SimpleReactValidator({});

export const validate = (prevValidation) => (dispatch, getState) => {
  const {
    stencilsToBuy,
    stencilsParameters,
    stencilsToDestroy,
  } = selectStencilsForValidation(getState());

  if (!stencilsToBuy ||
    !stencilsToBuy.length ||
    _.isEmpty(stencilsParameters) &&
    stencilsToBuy.filter((s) => {
      const { stencil_side, ...check_parameters } = s.parameters;
      return !_.isEmpty(check_parameters);
    }).length === 0) {
    return true;
  }

  const inputFile = document.getElementById('gerber-file');
  const file = inputFile ? inputFile.files[0] : null;

  if (stencilsToDestroy && stencilsToDestroy.length && !file) {
    toast.error('You have replaced the stencil(s) in your cart, please upload a new zip file for the new stencils.');
    return false;
  };


  if (!validator.allValid()) {
    validator.showMessages();
    dispatch(updateValidatorFlag());
    if (prevValidation) {
      dispatch(changeTab(TAB_STENCILS));
    }

    return false;
  }
  return true;
};
